import AccSetupReducer from "./acc-setup";
import AssetReducer from "./asset";
import AssetTypeReducer from "./asset-type";
import BankReducer from "./bank";
import BeginningBalanceReducer from "./beginning-balance";
import BudgetReducer from "./budget";
import CashBankReducer from "./cash-bank";
import ClosebookReducer from "./closebook";
import Coa1Reducer from "./coa1";
import Coa2Reducer from "./coa2";
import Coa3Reducer from "./coa3";
import Coa4Reducer from "./coa4";
import Coa5Reducer from "./coa5";
import ConfigurationReducer from "./configuration";
import DownPaymentReducer from "./down-payment";
import JournalReducer from "./journal";
import ListPaymentReducer from "./list-payment";
import LogBgReducer from "./log-bg";
import MemoInReducer from "./memo-in";
import MemoOutReducer from "./memo-out";

export default  {
    accsetup:AccSetupReducer,
    asset:AssetReducer,
    assetType:AssetTypeReducer,
    bank:BankReducer,
    beginningBalance:BeginningBalanceReducer,
    cashbank:CashBankReducer,
    closebook:ClosebookReducer,
    coa1:Coa1Reducer,
    coa2:Coa2Reducer,
    coa3:Coa3Reducer,
    coa4:Coa4Reducer,
    coa5:Coa5Reducer,
    configuration:ConfigurationReducer,
    downPayment:DownPaymentReducer,
    journal:JournalReducer,
    listPayment:ListPaymentReducer,
    logBg:LogBgReducer,
    memoin:MemoInReducer,
    memoout:MemoOutReducer,
    budget:BudgetReducer
}